import grpcClient from '~/grpc/grpc-client'
import { commonMetaData } from '~/store/_helpers/common-helper'

// initial state
export const state = () => ({})

// getters
export const getters = {}

// actions
export const actions = {
  async getAppsFlyerUrl({ rootState }, appsFlyerKey) {
    const [{ GetAppsFlyerUrlRequest }, { AppsFlyerUrlService }] = await Promise.all([
      import('~/stub/apigateway/apps_flyer/apps_flyer_url_pb'),
      import('~/stub/apigateway/apps_flyer/apps_flyer_url_pb_service')
    ])
    const request = new GetAppsFlyerUrlRequest()
    request.setAppsFlyerKey(appsFlyerKey)

    const metadata = commonMetaData(rootState)

    try {
      const response = await grpcClient({
        method: AppsFlyerUrlService.GetAppsFlyerUrl,
        request,
        metadata
      })
      return response.appsFlyerUrl
    } catch (e) {
      // NOTE: フロントの表示に影響が出ないように返却する
      return Promise.resolve(null)
    }
  }
}

// mutations
export const mutations = {}
